import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, Modal, Stack, Text, rem } from '@mantine/core';
import type { BuyCryptoModalProps } from './BuyCryptoModal';
import classes from './DepositBuyCrypto.module.css';
export const SuccessModal: React.FC<BuyCryptoModalProps> = ({
  stack
}) => {
  const {
    i18n
  } = useLingui();
  return <Modal.Root {...stack.register('success')} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header px={20} pt={32} pb={0}>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body pb={32} px={20}>
          <Stack align="center">
            <Image src="/assets/wallet/checked.png" alt="success" w={96} h={96} mb={16} />
            <Text fz={{
            base: 20,
            sm: 25
          }} lh={rem(25)} className={gunterzBold.className} c="var(--text-prime)">
              {i18n._('payment successful!')}
            </Text>
            <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
              {i18n._('you have completed your payment.')}
            </Text>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};